module.exports = __webpack_public_path__ + "img/upi.7a73fec3.svg";